import { SwapScreen } from './SwapScreen';
import type { Coin } from './TokenSheet';

/** Full-screen swap flow (ChangeHero). Mirrors SendFlow overlay pattern. */
export function SwapFlow({ onClose, coin }: { onClose: () => void; coin?: Coin }) {
  return (
    <div className="push-enter fixed inset-0 z-50 overflow-y-auto bg-surface">
      <SwapScreen onClose={onClose} initialFrom={coin} />
    </div>
  );
}
